import { Injectable , Inject, PLATFORM_ID } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import {ScriptStore} from "./script.store";
import {CssStore} from "./css.store";
import { isPlatformBrowser } from '@angular/common';
declare var document: any;

@Injectable()
export class ScriptService {
	private scripts: any = {};
	private css: any = {};
	constructor(@Inject(PLATFORM_ID) private platformId: object,@Inject(DOCUMENT) private document: Document) {
		ScriptStore.forEach((script: any) => {
			this.scripts[script.name] = {
				loaded: false,
				src: script.src
			};
		});
		CssStore.forEach((myCss: any) => {
			this.css[myCss.name] = {
				loaded: false,
				src: myCss.src
			};
		});
	}
	load(...scripts: string[]) {
		var promises: any[] = [];
		scripts.forEach((script) => promises.push(this.loadScript(script)));
		return Promise.all(promises);
	}
	loadScript(name: string) {
		return new Promise((resolve, reject) => {
			//resolve if already loaded
			if (this.scripts[name].loaded) {
				resolve({script: name, loaded: true, status: 'Already Loaded'});
			}
			else {
				//load script
				if (isPlatformBrowser(this.platformId)){
					let script = document.createElement('script');
					script.type = 'text/javascript';
					script.src = this.scripts[name].src;
					if (script.readyState) {  //IE
						script.onreadystatechange = () => {
							if (script.readyState === "loaded" || script.readyState === "complete") {
								script.onreadystatechange = null;
								this.scripts[name].loaded = true;
								resolve({script: name, loaded: true, status: 'Loaded'});
							}
						};
					} else {  //Others
						script.onload = () => {
							this.scripts[name].loaded = true;
							resolve({script: name, loaded: true, status: 'Loaded'});
						};
					}
					script.onerror = (error: any) => resolve({script: name, loaded: false, status: 'Loaded'});
					document.getElementsByTagName('head')[0].appendChild(script);
				}
			}
		});
	}

	cssload(...css: string[]) {
		var promises: any[] = [];
		css.forEach((myCss) => promises.push(this.cssloadScript(myCss)));
		return Promise.all(promises);
	}
	cssloadScript(name: string) {
		return new Promise((resolve, reject) => {
			//resolve if already loaded
			if (this.css[name].loaded) {
				resolve({myCss: name, loaded: true, status: 'Already Loaded'});
			}
			else {
				//load css
				if (isPlatformBrowser(this.platformId)){
					let myCss = document.createElement('link');
					myCss.rel = 'stylesheet';
					myCss.href = this.css[name].src;
					if (myCss.readyState) {  //IE
						myCss.onreadystatechange = () => {
							if (myCss.readyState === "loaded" || myCss.readyState === "complete") {
								myCss.onreadystatechange = null;
								this.css[name].loaded = true;
								resolve({myCss: name, loaded: true, status: 'Loaded'});
							}
						};
					} else {  //Others
						myCss.onload = () => {
							this.css[name].loaded = true;
							resolve({myCss: name, loaded: true, status: 'Loaded'});
						};
					}
					myCss.onerror = (error: any) => resolve({myCss: name, loaded: false, status: 'Loaded'});
					document.getElementsByTagName('head')[0].appendChild(myCss);
				}
			}
		});
	}
}
